module.exports = __webpack_public_path__ + "img/nms-demo1.23a35efa.png";